// extracted by mini-css-extract-plugin
export var contentSection = "_c-8";
export var imageSection = "_c-1";
export var productGrid = "_c-0";
export var productImage = "_c-3";
export var productImageContainer = "_c-2";
export var productInfo = "_c-9";
export var purchaseControls = "_c-a";
export var quantityInput = "_c-c";
export var selectedThumbnail = "_c-6";
export var thumbnailContainer = "_c-4";
export var thumbnailImage = "_c-7";
export var thumbnailItem = "_c-5";
export var variantSelect = "_c-b";